// src/components/JotformAgent.js
import { useEffect } from "react";

// Module-level guard: the embed script declares top-level identifiers that
// survive removing the <script> tag, so StrictMode's dev-mode double-mount
// (mount -> cleanup -> mount) would otherwise inject it twice and throw.
let jotformScriptInjected = false;

export default function JotformAgent() {
  useEffect(() => {
    if (jotformScriptInjected) return;
    jotformScriptInjected = true;

    const script = document.createElement("script");
    script.src = "https://cdn.jotfor.ms/agent/embedjs/01981c7c4d467818ae6f87afad4f3773fdc1/embed.js?skipWelcome=1&maximizable=1&isVoice=1";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return null;
}
